import PaymentIntentMapper, {
  PaymentIntentData,
} from '../../../../entities/mappers/writer/my_stripe/PaymentIntentMapper';

import PaymentIntent from '../../../../../domain/entities/writer/my_stripe/PaymentIntent';
import SubscriptionPaymentIntentRepository from '../../../../../domain/repositories/writer/my_stripe/maker_pro/SubscriptionPaymentIntentRepository';

import TapNovelRestApi from '../../../../data_stores/net/TapNovelRestApi';

export default class NetSubscriptionPaymentIntentRepository
  implements SubscriptionPaymentIntentRepository
{
  private endPoint =
    '/api/writer/my_stripe/maker_pro/subscription_payment_intent';
  public mapper = new PaymentIntentMapper();

  constructor() {}

  public async create(
    params: {[key: string]: any},
    options?: {[key: string]: any},
  ): Promise<PaymentIntent> {
    const path = this.endPoint;
    const obj = await TapNovelRestApi.post<PaymentIntentData>(
      path,
      params,
      options,
    );
    return this.mapper.map(obj.body);
  }
}
